<template>
  <div class="container">
    <table class="table table-striped" style="border: 1px solid #000;">
      <thead>
        <tr>
          <th scope="col" colspan="2">Variabless</th>
          <th scope="col">{{ Yeartwo }}</th>
          <th scope="col">{{ YearOne }}</th>
          <th scope="col">{{ varEntorno }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row" colspan="2">{{ textOne }}</th>
          <td>
            {{ sumaOne }}
          </td>
          <td>{{ sumaTwo }}</td>
          <td>
            {{ sumaThree }}
          </td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textTwo }}</th>
          <td>{{ datsa.Contrata + datsa.Planta }}</td>
          <td>{{ datsaUno.Contrata + datsaUno.Planta }}</td>
          <td>{{ dasta.Contrata + dasta.Planta }}</td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textThree }}</th>
          <td>{{ intPorcentajeOne }}%</td>
          <td>{{ intPorcentajeTwo }}%</td>
          <td>{{ intPorcentajeThree }}%</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import store from "../../../../../store";
import axios from "axios";
export default {
  props: ["ceseRetiro"],
  components: {},
  data() {
    return {
      textOne:
        "(a) N° de funcionarios que cesan o se retiran del Servicio por cualquier causal año t",
      textTwo: "(b) Total dotación efectiva año t",
      textThree: "Porcentaje de funcionarios que cesan o se retiran (a/b)",
      varEntorno: `${process.env.VUE_APP_ANIO}`,
      YearOne: "",
      Yeartwo: "",
      YearThre: "",
      data: "1",
      dataTwo: "2",

      porcentajeOne: "",
      porcentajeTwo: "",
      porcentajeThree: "",
      porcentaje: "100",
      intPorcentajeOne: null,
      intPorcentajeTwo: null,
      intPorcentajeThree: null,
      tablasData: null,
      datsa: null,
      datsaUno: null,
      dasta: null,
      sumaOne: 0,
      sumaTwo: 0,
      sumaThree: 0,
    };
  },

  methods: {
    obtenerContenido: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?anexo=2&servicio=${this.$route.params.idServicio}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data === undefined) {
          this.datos = true;
        }
        this.datsa =
          res.data[0].datos.indicadores[`${process.env.VUE_APP_ANIO}` - 2][0];
        this.datsaUno =
          res.data[0].datos.indicadores[`${process.env.VUE_APP_ANIO}` - 1][0];
        this.dasta =
          res.data[0].datos.indicadores[`${process.env.VUE_APP_ANIO}`][0];
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.YearOne = parseInt(this.varEntorno) - parseInt(this.data);
    this.Yeartwo = parseInt(this.varEntorno) - parseInt(this.dataTwo);
    this.obtenerContenido();

    // setTimeout(() => {
    //   this.tablasData = this.tableOne.porcentajeEgresos;
    // }, 4000);
  },
  updated() {
    this.sumaOne =
      parseInt(this.ceseRetiro.inputOne) +
      parseInt(this.ceseRetiro.inputFour) +
      parseInt(this.ceseRetiro.inputSeven) +
      parseInt(this.ceseRetiro.inputThirteen) +
      parseInt(this.ceseRetiro.inputTen);

    this.sumaTwo =
      parseInt(this.ceseRetiro.inputTwo) +
      parseInt(this.ceseRetiro.inputFive) +
      parseInt(this.ceseRetiro.inputEight) +
      parseInt(this.ceseRetiro.inputEleven) +
      parseInt(this.ceseRetiro.inputFourteen);

    this.sumaThree =
      parseInt(this.ceseRetiro.inputThree) +
      parseInt(this.ceseRetiro.inputSix) +
      parseInt(this.ceseRetiro.inputNine) +
      parseInt(this.ceseRetiro.inputTwelve) +
      parseInt(this.ceseRetiro.inputFifteen);

    // Primer porcentaje
    this.porcentajeOne =
      (parseInt(this.sumaOne) /
        parseInt(this.datsa.Contrata + this.datsa.Planta)) *
      parseInt(this.porcentaje);
    this.intPorcentajeOne = this.porcentajeOne.toFixed(2);

    //Segundo Porcentaje
    this.porcentajeTwo =
      (parseInt(this.sumaTwo) /
        parseInt(this.datsaUno.Contrata + this.datsaUno.Planta)) *
      parseInt(this.porcentaje);
    this.intPorcentajeTwo = this.porcentajeTwo.toFixed(2);

    //Tercer Porcentaje
    this.porcentajeThree =
      (parseInt(this.sumaThree) /
        parseInt(this.dasta.Contrata + this.dasta.Planta)) *
      parseInt(this.porcentaje);
    this.intPorcentajeThree = this.porcentajeThree.toFixed(2);

    // store.dispatch("rHumanos/actionsTable", {
    //   value: [
    //     {
    //       title: this.textOne,
    //       anioTwo: this.inputOne,
    //       anioOne: this.inputTwo,
    //       anio: this.inputThree,
    //     },
    //     {
    //       title: this.textTwo,
    //       anioTwo: this.inputFour,
    //       anioOne: this.inputFive,
    //       anio: this.inputSix,
    //     },
    //     {
    //       title: this.textThree,
    //       anioTwo: this.intPorcentajeOne,
    //       anioOne: this.intPorcentajeTwo,
    //       anio: this.intPorcentajeThree,
    //     },
    //   ],
    //   nameTable: "porcentajeEgresos",
    // });
  },
};
</script>

<style scoped>
th {
  text-align: left !important;
  font-size: 14px !important ;
}

.div {
  border: 1px solid #000;
  width: 96%;
  height: 26px;
  position: relative;
  left: 3px;
  background-color: #fff;
}
</style>
